
import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { pageText } from "../ComponentContext";
import styles from "../index.module.css";
import type { MenuProps, UploadProps } from "antd";
import { Button, Dropdown, message, Space, Tooltip, Upload } from "antd";
import { ArrowDownOutlined, CloudDownloadOutlined, CloudUploadOutlined, CopyOutlined, DownloadOutlined, FilePptOutlined, FileTextOutlined, FileZipOutlined, UploadOutlined } from "@ant-design/icons";
import { streamerInit, loadIfcFile, loadFragFile, loadGltfFile, resetBbox,focusHome, clipperModel, postRendererOn, dimensionOn,
  angleOn, areaOn, edgeOn, faceOn, volumeOn, clearMeasure, 
  modelsListOn, propertiesOn, classificationsOn, relationsOn, disposeModel, exploderModel,cameraTypeSet,
  exportPropertyJson,
  exportToFrag,
  exportRelationJson,
  exportStreamFiles,
  exportStreamProps,
  loadRelations,
  loadPropertys,
  } from "./ifcLibrary";
import {
  MeasureDistance,
  MeasureAngular,
  Measure,
  MeasureArea,
  MeasureValume,
  MeasureClean,
  HomeIcon,
  CutIcon,
  CameraIcon,
  RenderIcon,
  PropertyIcon,
  OpenIcon,
  ShowDistance,
  RelationTreeIcon,
  ModelListIcon,
  ClassTreeIcon,
  CleanModelIcon,
  DownloadIfcIcon,
  ExploderIcon,
  StreamerLoadIcon,
  FirstPersonIcon,
  WorldCameraIcon,
  PlanCameraIcon,
  OrthCameraIcon,
  PerCameraIcon,
} from "../sunIcons"; 

export let model: any;

const BottomPanel = ({}, ref: any) => {
  const { loading, setLoading, exploderActive, setExploderActive, 
    leftActive, setLeftActive, rightActive, setRightActive,  
    leftActiveKey, setLeftActiveKey, rightActiveKey, setRightActiveKey,
    cameraType, setCameraType, projectionType, setProjectionType,
  } = useContext(pageText);

  useImperativeHandle(ref, () => ({ 
    resetBbox,
    openFile,
    cameraTypeSet,
    setRightActive, setRightActiveKey,
    setLeftActive, setLeftActiveKey,
    loadStreamer,loadTestIfc
  })); 

  // 是否激活颜色
  const getActiveColor = (v: boolean) => {
    return v ? '#1677ff': '#666666';
  }
  // 模型加载回调
  const callBackLoading = (status: boolean) => {
    if(!status){
      message.warning('没有可操作模型')
    }     
    setLoading(false)
  }
  // 打开文件
  const openFile = async (file: any) => { 
    const dotIndex = file.name.lastIndexOf(".");
    const fileType = dotIndex === -1 ? "" : file.name.slice(dotIndex + 1);
    if (fileType == "ifc") {
      relationsOn()
      setLoading(true)
      loadIfcFile(file, callBackLoading);
    } else if (fileType == "frag") {
      setLoading(true);
      loadFragFile(file, callBackLoading);
    } else if(fileType == "gltf" || fileType == "glb") {
      setLoading(true);
      loadGltfFile(file, callBackLoading);
    } else {
      message.warning("请选择.ifc或.frag或.gltf或.glb格式文件");
    }
  };

  // 载入分片模型
  const loadStreamer = async () => {
    setCameraType('FirstPerson')
    cameraTypeSet(cameraType, projectionType)
    const initData = {
      url: import.meta.env.DEV
        ? "/streamer-proxy/"
        : "https://pad.sunopenbim.com/streamerFiles/",
      geometry: "small.ifc-processed.json",
      property: 'small.ifc-processed-properties.json',
      // propertyAll: "properties.json",
      threshold: 1,
      maxHiddenTime: 1000,
      maxLostTime: 9000,
      cb: callBackLoading,
    };
  
    streamerInit(initData);
  };
  // 测试载入13号线模型+管线
  const loadTestIfc = async () => {
    relationsOn() 
    const ifcUrls = [
      {url: "/ifcFiles/19_rue_Marc_Antoine_Petit_Ground_floor.ifc", name: 'IFC文件'},
      // {url: "/ifcFiles/tujian13.ifc", name: '松溪站-土建+机电'},
      // {url: "/ifcFiles/guanzong13.ifc", name: '松溪站-管综模型'}
    ]
    for(let i = 0; i < ifcUrls.length; i++) {
      setLoading(true);
      let file: any = await fetch(ifcUrls[i].url);
      file.name = ifcUrls[i].name
      await loadIfcFile(file, callBackLoading); 
    }
     
  };
 
  const loadBuildingIfc = async () => {
    relationsOn()
    const ifcList = ["allfloor","building","electrical","elevenfloor","firstfloor","stair","structure","top","water","heating"]
    const nameList = ["楼层","建筑","电路","十七楼","首层","楼梯","结构","顶层","给排水","暖通"]
    let waitTime = 0
    for(let i = 0; i < ifcList.length; i++) {
      setLoading(true);
      let file: any = await fetch(`/building/${ifcList[i]}.ifc`);
      file.name = nameList[i]
      await loadIfcFile(file, callBackLoading); 
    }

   }
  // 载入测试frag站房模型
  const loadFragTestZhanfang = async() => {
    setLoading(true);
    const fragUrls = [
      {url: "/fragFiles/zhanfang.frag", name: '松溪站-土建+机电', relationUrl: '/fragFiles/zhanfangrelation.json', propertyUrl: '/fragFiles/zhanfangproperties.json'},
      {url: "/fragFiles/jidian.frag", name: '松溪站-管综模型', relationUrl: '/fragFiles/jidianrelation.json', propertyUrl: '/fragFiles/jidianproperties.json'}
    ]

    for(let i = 0; i < fragUrls.length; i++){
      const file: any = await fetch(fragUrls[i].url); 
      file.name = fragUrls[i].name
      await loadFragFile(file, callBackLoading);
      const relationsIndexFile = await fetch(fragUrls[i].relationUrl); 
      const fileText = await relationsIndexFile.text();
      await loadRelations(fileText, fragUrls[i].name)
      const properties = await fetch(fragUrls[i].propertyUrl);
      const propertyData = await properties.json()
      loadPropertys(propertyData, fragUrls[i].name)
    }
  }

  // 导出分片文件流
  const downloadStreamFiles = async () => {
    setLoading(true)
    exportStreamFiles(callBackLoading)
  }
  

  // 模型分解
  const exploderHandler = async () => {
    exploderModel(setExploderActive, callBackLoading)
  }
  // 测量菜单
  const items: MenuProps["items"] = [
    {
      label: (
        <Tooltip title="距离测量" placement="right">
          <Button
            type="link"
            onClick={dimensionOn}
            icon={<MeasureDistance size="20px" />}
          />
        </Tooltip>
      ),
      key: "0",
    },
    {
      label: (
        <Tooltip title="角度测量" placement="right">
          <Button
            type="link"
            onClick={angleOn}
            icon={<MeasureAngular size="20px" />}
          />
        </Tooltip>
      ),
      key: "1",
    },
    {
      label: (
        <Tooltip title="面积测量" placement="right">
          <Button
            type="link"
            onClick={areaOn}
            icon={<MeasureArea size="20px" />}
          />
        </Tooltip>
      ),
      key: "2",
    },
    {
      label: (
        <Tooltip title="体积测量" placement="right">
          <Button
            type="link"
            onClick={volumeOn}
            icon={<MeasureValume size="20px" />}
          />
        </Tooltip>
      ),
      key: "3",
    },
    {
      label: (
        <Tooltip title="显示边长" placement="right">
          <Button
            type="link"
            onClick={edgeOn}
            icon={<ShowDistance size="20px" />}
          />
        </Tooltip>
      ),
      key: "4",
    },
    {
      label: (
        <Tooltip title="显示面积" placement="right">
          <Button
            type="link"
            onClick={faceOn}
            icon={<MeasureValume size="20px" />}
          />
        </Tooltip>
      ),
      key: "5",
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Tooltip title="清除测量" placement="right">
          <Button
            type="link"
            onClick={clearMeasure}
            icon={<MeasureClean size="20px" />}
          />
        </Tooltip>
      ),
      key: "10",
    },
  ];

  const cameraItems: MenuProps["items"] = [
    {
      label: (
        <Tooltip title="第一人称视角" placement="right">
          <Button
            type="link"
            onClick={() => {
              setCameraType("FirstPerson")
              cameraTypeSet("FirstPerson", projectionType)
            }}
            icon={<FirstPersonIcon size="20px" color={getActiveColor(cameraType == 'FirstPerson')} />}
          />
        </Tooltip>
      ),
      key: "c1",
    },
    {
      label: (
        <Tooltip title="自由视角" placement="right">
          <Button
            type="link"
            onClick={() => {
              setCameraType("Orbit")
              cameraTypeSet("Orbit", projectionType)
            }}
            icon={<WorldCameraIcon size="20px" color={getActiveColor(cameraType == 'Orbit')} />}
          />
        </Tooltip>
      ),
      key: "c2",
    },
    {
      label: (
        <Tooltip title="物体视角" placement="right">
          <Button
            type="link"
            onClick={() => {
              setCameraType("Plan")
              cameraTypeSet("Plan", projectionType)
            }}
            icon={<PlanCameraIcon size="20px" color={getActiveColor(cameraType == 'Plan')} />}
          />
        </Tooltip>
      ),
      key: "c3",
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Tooltip title="正交相机" placement="right">
          <Button
            type="link"
            onClick={() => {
              setProjectionType("Perspective")
              cameraTypeSet(cameraType, "Perspective")
            }}
            icon={<OrthCameraIcon size="20px" color={getActiveColor(projectionType == 'Perspective')} />}
          />
        </Tooltip>
      ),
      key: "c10",
    },
    {
      label: (
        <Tooltip title="透视相机" placement="right">
          <Button
            type="link"
            onClick={() => {
              setProjectionType("Orthographic")
              cameraTypeSet(cameraType, "Orthographic")
            }}
            icon={<PerCameraIcon size="20px" color={getActiveColor(projectionType == 'Orthographic')} />}
          />
        </Tooltip>
      ),
      key: "c11",
    },
    
  ]

  // demo菜单
  const demoItems: MenuProps["items"] = [
    {
      label: (
        <Button
          type="text"
          onClick={loadTestIfc} 
          icon={<ArrowDownOutlined />}
        >载入IFC松溪站模型</Button>
      ),
      key: "0",
    },
    {
      label: (
        <Button
          type="text"
          onClick={loadFragTestZhanfang} 
          icon={<DownloadOutlined />}
        >载入frag松溪站模型</Button>
      ),
      key: "1",
    },
    {
      label: (
        <Button
          type="text"
          onClick={loadStreamer} 
          icon={<CloudDownloadOutlined />}
        >载入分片模型</Button>
      ),
      key: "2",
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Button
          type="text"
          onClick={loadBuildingIfc} 
          icon={<ArrowDownOutlined />}
        >载入IFC大楼模型</Button>
      ),
      key: "10",
    },
    
  ]; 

  // 导出json菜单
  const exportItems: MenuProps["items"] = [
    {
      label: (
        <Button
          type="text"
          onClick={() => exportToFrag(callBackLoading)} 
          icon={<FileTextOutlined />}
        >导出为frag文件</Button>
      ),
      key: "j0",
    },
    {
      label: (
        <Button
          type="text"
          onClick={() => exportPropertyJson(callBackLoading)} 
          icon={<FilePptOutlined />}
        >导出属性json</Button>
      ),
      key: "j2",
    },
    {
      label: (
        <Button
          type="text"
          onClick={exportRelationJson} 
          icon={<UploadOutlined />}
        >导出关系树json</Button>
      ),
      key: "j3",
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Button
          type="text"
          onClick={ downloadStreamFiles } 
          icon={<FileZipOutlined />}
        >导出为分片文件</Button>
      ),
      key: "j10",
    },
    {
      label: (
        <Button
          type="text"
          onClick={ () => {
            setLoading(true)
            exportStreamProps(callBackLoading)
          } } 
          icon={<CopyOutlined />}
        >导出分片属性json</Button>
      ),
      key: "j11",
    },
  ]

  // 上传文件
  const uploadProps: UploadProps = {
    name: "file",
    // multiple: false,
    multiple: true,
    showUploadList: false,
    // action: '',
    customRequest({ file }) {
      openFile(file);
    },
  };

  return (
    <div className={styles.bottomPanel3D}>
      <Tooltip title="主视图" placement="bottom">
        <Button
          type="link"
          onClick={focusHome}
          icon={<HomeIcon size="30px" />}
        ></Button>
      </Tooltip>  
      <Dropdown menu={{ items: cameraItems }}>
        <Button type="link" icon={<CameraIcon size="30px" />} />
      </Dropdown>   
      <Dropdown menu={{ items }}>
        <Button type="link" icon={<Measure size="30px" />} />
      </Dropdown> 
      <Tooltip title="导航栏" placement="bottom">
        <Button
          type="link"
          onClick={()=> {
            modelsListOn()
            relationsOn()
            classificationsOn()
            setLeftActive(!leftActive)
            setLeftActiveKey('modelList')

          }}
          icon={<RelationTreeIcon size="26px" />}
        />
      </Tooltip>
      <Tooltip title="属性详情" placement="bottom">
        <Button
          type="link"
          onClick={() => {
            propertiesOn();
            postRendererOn();
            setRightActive(true)
            setRightActiveKey('propertySet')
          }}
          icon={<PropertyIcon size="30px" />}
        />
      </Tooltip>

      <Tooltip title="剖切" placement="bottom">
        <Button
          type="link"
          onClick={() => {
            setRightActive(true)
            setRightActiveKey('clipperSet')
            clipperModel()
          }}
          icon={<CutIcon size="30px" />}
        />
      </Tooltip>
      <Tooltip title="渲染设置" placement="bottom">
        <Button
          type="link"
          onClick={() => {
            postRendererOn();
            setRightActive(true)
            setRightActiveKey('renderSet')
          }}
          icon={<RenderIcon size="30px" />}
        />
      </Tooltip>  
      {/* <Tooltip title="分解模型" placement="bottom">
      <Button
          type='link'
          onClick={exploderHandler}
          icon={<ExploderIcon color={getActiveColor(exploderActive)} size="30px" />}
        />
      </Tooltip> */}
         
      {/* <Tooltip title="模型列表" placement="bottom">
        <Button
          type="link"
          onClick={modelsListOn}
          icon={<ModelListIcon size="30px" />}
        />
      </Tooltip>   
      <Tooltip title="分类树" placement="bottom">
        <Button
          type="link"
          onClick={classificationsOn}
          icon={<ClassTreeIcon size="30px" />}
        />
      </Tooltip>   */} 
      
      <Tooltip title="打开文件" placement="bottom">
        <Upload {...uploadProps}>
          <Button
            type="link"
            icon={<OpenIcon size="30px" />}
          />
        </Upload>
      </Tooltip>
      
      {/* <Tooltip title="关闭模型" placement="bottom">
        <Button
          type="link"
          onClick={disposeModel}
          icon={<CleanModelIcon size="26px" />}
        />
      </Tooltip> */}
       
       {/* <Tooltip title="载入测试文件" placement="bottom">
        <Button
          type="link"
          // onClick={loadTestIfc}
          onClick={loadFragTestZhanfang}
          icon={<DownloadIfcIcon size="26px" />}
        />
      </Tooltip> */}
      {/* <Tooltip title="载入分片模型" placement="bottom">
        <Button
          type="link"
          onClick={loadStreamer}
          icon={<StreamerLoadIcon size="26px" />}
        />
      </Tooltip> */}
      {/* <Dropdown menu={{ items: demoItems }}>
        <Button type="link" icon={<DownloadIfcIcon size="30px" />} />
      </Dropdown>
      
      <Dropdown menu={{ items: exportItems }}>
        <Button type="link" icon={<StreamerLoadIcon size="30px" />} />
      </Dropdown> */}
    </div>
  );
};

export default forwardRef(BottomPanel);
